import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import RoupasImpecaveisTempoParaVoce from "./sections/RoupasImpecaveisTempoParaVoce";
import OurAgencysDna from "./sections/OurAgencysDna";
import CoreIntelligenceTracks from "./sections/CoreIntelligenceTracks";
import LiveFromTheStudio from "./sections/LiveFromTheStudio";
import ThePerfectProtocol from "./sections/ThePerfectProtocol";
import ClaimYourSuccess from "./sections/ClaimYourSuccess";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <RoupasImpecaveisTempoParaVoce />
      <OurAgencysDna />
      <CoreIntelligenceTracks />
      <LiveFromTheStudio />
      <ThePerfectProtocol />
      <ClaimYourSuccess />
      <Footer />
    </div>;
}